export const translations = {
  pt: {
    nav: {
      products: "PRODUTOS",
      editorial: "EDITORIAL",
      services: "SERVIÇOS",
      contact: "CONTATO",
    },
    hero: {
      tag: "ESTÚDIO · EST. 2013",
      title1: "TECH &",
      title2: "DESIGN",
      titleItalic: "Studio",
      description:
        "No Lab2513 unimos a precisão do código à alma do design editorial. Do desenvolvimento de plataformas SaaS à diagramação de livros e painéis gráficos, criamos ferramentas e artefatos para o mundo moderno.",
      cta: "CONVERSAR COM O LAB",
    },
    ticker: [
      "SAAS · PRODUTIVIDADE",
      "DESIGN EDITORIAL",
      "PAINÉIS GRÁFICOS",
      "DESENVOLVIMENTO WEB",
      "IDENTIDADE VISUAL",
      "TECNOLOGIA APLICADA",
    ],
    products: {
      tag: "ECOSSISTEMA DE PRODUTOS",
      title: "Startups nascidas no laboratório.",
      subtitle:
        "Nossa suíte de produtos SaaS proprietários, resolvendo problemas de memória, engajamento e produtividade.",
      cards: [
        {
          name: "DóRéMigos",
          category: "MARCA · INFANTIL",
          description:
            "Marca 360° de música infantil. Onde a música vira amizade e a imaginação vira brincadeira. Narrativa, produto, experiência e shows ao vivo.",
          action: "CONHECER",
          status: "live",
        },
        {
          name: "PinWin",
          category: "SAAS · SQUADS",
          description:
            "Pin the win. Rule the squad. Plataforma gamificada para times de alta performance transformarem conquistas em cultura.",
          action: "EM BREVE",
          status: "soon",
        },
        {
          name: "Nico",
          category: "ASSISTENTE TÉCNICO",
          description:
            "Seu mascote técnico e infraestrutura de suporte com personalidade.",
          action: "",
          status: "mascot",
        },
      ],
    },
    editorial: {
      tag: "DESIGN & DIAGRAMAÇÃO",
      title1: "Livros, Periódicos",
      title2: "& Painéis Gráficos.",
      subtitle:
        "Traduzimos informação complexa em estruturas belas e legíveis — de volumes editoriais a painéis gráficos industriais.",
      items: [
        { n: "01", title: "DESIGN EDITORIAL", desc: "Diagramação completa de livros, revistas e periódicos." },
        { n: "02", title: "PAINÉIS GRÁFICOS", desc: "Design de informação para painéis técnicos e ambientes industriais." },
        { n: "03", title: "DESENVOLVIMENTO SAAS", desc: "Do protótipo à infraestrutura em nuvem, sob medida." },
      ],
    },
    cta: {
      title1: "Tem um projeto?",
      title2: "Fale com o Lab.",
      description:
        "SaaS, produto editorial ou painel gráfico — se envolve tecnologia e design, é assunto nosso.",
      button: "CONTATO@LAB2513.COM.BR",
    },
    footer: {
      subtitle: "TECNOLOGIA E DESIGN · BRASIL",
      email: "contato@lab2513.com.br",
      copyright: "© 2026 Lab2513",
    },
    form: {
      title: "Fale com o Lab.",
      subtitle: "Nos conte sobre o seu projeto — respondemos em até 48h.",
      name: "Nome",
      email: "E-mail",
      message: "Mensagem",
      namePh: "Como podemos te chamar?",
      emailPh: "seu@email.com",
      messagePh: "Sobre o que você quer conversar?",
      submit: "ENVIAR MENSAGEM",
      submitting: "ENVIANDO...",
      success: "Mensagem enviada. O Lab vai te retornar em breve.",
      error: "Não foi possível enviar. Tente novamente.",
      close: "Fechar",
    },
  },
  en: {
    nav: {
      products: "PRODUCTS",
      editorial: "EDITORIAL",
      services: "SERVICES",
      contact: "CONTACT",
    },
    hero: {
      tag: "STUDIO · EST. 2013",
      title1: "TECH &",
      title2: "DESIGN",
      titleItalic: "Studio",
      description:
        "At Lab2513 we blend the precision of code with the soul of editorial design. From building SaaS platforms to laying out books and graphic panels, we craft tools and artifacts for the modern world.",
      cta: "TALK TO THE LAB",
    },
    ticker: [
      "SAAS · PRODUCTIVITY",
      "EDITORIAL DESIGN",
      "GRAPHIC PANELS",
      "WEB DEVELOPMENT",
      "VISUAL IDENTITY",
      "APPLIED TECHNOLOGY",
    ],
    products: {
      tag: "PRODUCT ECOSYSTEM",
      title: "Startups born in the lab.",
      subtitle:
        "Our suite of proprietary SaaS products, solving problems of memory, engagement and productivity.",
      cards: [
        {
          name: "DóRéMigos",
          category: "BRAND · KIDS",
          description:
            "A 360° children's music brand. Where music becomes friendship and imagination becomes play. Storytelling, product, experience and live shows.",
          action: "LEARN MORE",
          status: "live",
        },
        {
          name: "PinWin",
          category: "SAAS · SQUADS",
          description:
            "Pin the win. Rule the squad. A gamified platform for high-performance teams to turn wins into culture.",
          action: "COMING SOON",
          status: "soon",
        },
        {
          name: "Nico",
          category: "TECH ASSISTANT",
          description:
            "Your technical mascot and support infrastructure — with personality.",
          action: "",
          status: "mascot",
        },
      ],
    },
    editorial: {
      tag: "DESIGN & LAYOUT",
      title1: "Books, Periodicals",
      title2: "& Graphic Panels.",
      subtitle:
        "We translate complex information into beautiful, readable structures — from editorial volumes to industrial graphic panels.",
      items: [
        { n: "01", title: "EDITORIAL DESIGN", desc: "Full layout for books, magazines and periodicals." },
        { n: "02", title: "GRAPHIC PANELS", desc: "Information design for technical panels and industrial environments." },
        { n: "03", title: "SAAS DEVELOPMENT", desc: "From prototype to cloud infrastructure, tailor-made." },
      ],
    },
    cta: {
      title1: "Got a project?",
      title2: "Talk to the Lab.",
      description:
        "SaaS, editorial product or graphic panel — if it involves technology and design, it's our thing.",
      button: "CONTATO@LAB2513.COM.BR",
    },
    footer: {
      subtitle: "TECHNOLOGY & DESIGN · BRAZIL",
      email: "contato@lab2513.com.br",
      copyright: "© 2026 Lab2513",
    },
    form: {
      title: "Talk to the Lab.",
      subtitle: "Tell us about your project — we reply within 48h.",
      name: "Name",
      email: "Email",
      message: "Message",
      namePh: "What should we call you?",
      emailPh: "you@email.com",
      messagePh: "What do you want to talk about?",
      submit: "SEND MESSAGE",
      submitting: "SENDING...",
      success: "Message sent. The Lab will get back to you soon.",
      error: "We couldn't send it. Please try again.",
      close: "Close",
    },
  },
};

export const defaultLocale = "pt";
